module.exports = __webpack_public_path__ + "static/media/g4.dea6e63f.png";